import { useMsal } from '@azure/msal-react'
import React, { FC, useEffect } from 'react'
import { loginRequest } from '../services/AuthConfig'
import { InteractionRequiredAuthError } from '@azure/msal-browser'
import { useTranslation } from 'react-i18next'

const Logout: FC = () => {
  const { instance } = useMsal()
  const { t } = useTranslation()
  useEffect(() => {
    instance
      .ssoSilent({ ...loginRequest })
      .then(({ idToken }) => {
        instance.logoutRedirect({
          idTokenHint: idToken,
          account: instance.getActiveAccount(),
        })
      })
      .catch((err) => {
        if (err instanceof InteractionRequiredAuthError) {
          document.cookie = `refreshIdentity=true; path=/; max-age=3; domain=.sistemiv.com`
          window.close()
        }
      })
  }, [instance])
  return <div>{t('logout')}</div>
}

export default Logout
